import { Link } from "react-router-dom";
import { usePageMeta } from "@/lib/seo";
import { STORE_ADDRESS, STORE_PHONE } from "@/constants/store";

const S = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-display font-bold text-lg text-[#0A1C40]">{title}</h2>
    <div className="mt-2 text-sm text-gray-700 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function TermsPage() {
  usePageMeta("Terms of Service", "Terms of Service for shopping at IPVALUE MARKETPLACE.");
  return (
    <div className="max-w-[860px] mx-auto px-6 py-12" data-testid="terms-page">
      <div className="ipv-eyebrow text-[#0A1C40]">Policies</div>
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-3">Terms of Service</h1>
      <p className="text-sm text-gray-500 mt-3">IPVALUE MARKETPLACE LLC · {STORE_ADDRESS.short} · Last updated June 2026</p>

      <S title="Who we are">
        <p>IPVALUE MARKETPLACE is a closeout and overstock retailer in Grand Rapids, Michigan. Every item is tagged honestly — NEW, OPEN BOX, or AS-IS — and priced on its own merit. By placing an order on this site you agree to these terms and to the policies linked in our footer.</p>
      </S>
      <S title="Orders & payment">
        <p>Payments for general merchandise are processed securely by Square. Adult wellness and tobacco accessory items are processed by Shopify. Michigan 6% sales tax applies. Card payments may carry a processing fee where posted. A $50 deposit hold reserves eligible items for 7 days; the deposit applies to your total and is non-refundable if the purchase is not completed.</p>
      </S>
      <S title="Pickup & delivery">
        <p>Pickup is free, same-day, during store hours. Local delivery follows our published fee table and Tuesday / Thursday / Saturday schedule — see the <Link to="/policies/delivery" className="underline font-semibold">Delivery &amp; Pickup policy</Link>. Inspect delivered items and note any damage on the delivery receipt before the driver leaves.</p>
      </S>
      <S title="Returns">
        <p>In-store items: 14-day exchange or store credit with receipt, item unused in original packaging — no cash refunds. Certain items are final sale. Shipped-to-you items follow a standard mail return process with refunds to your original payment method. See the <Link to="/policies/returns" className="underline font-semibold">Return &amp; Exchange policy</Link>. Pallet sales are final and governed by the <Link to="/policies/pallets" className="underline font-semibold">Pallet Sales policy</Link>.</p>
      </S>
      <S title="Age-restricted departments">
        <p>The adult wellness department is 18+ and all sales are final. Tobacco accessories are 21+ with government photo ID checked on every purchase, including at pickup or delivery for online orders.</p>
      </S>
      <S title="Resale purchases">
        <p>Tax-exempt resale purchases require a completed Michigan Form 3372 on file BEFORE payment. Otherwise Michigan sales tax is charged.</p>
      </S>
      <S title="Liability & disputes">
        <p>Products are sold as tagged. To the fullest extent permitted by Michigan law, our liability is limited to the amount you paid for the item. These terms are governed by the laws of the State of Michigan.</p>
      </S>
      <S title="Contact">
        <p>Questions? Call {STORE_PHONE} — our direct line for anything — or visit {STORE_ADDRESS.short}.</p>
      </S>
    </div>
  );
}
